import i18next from "../i18n";

export const projects = {
  sectionTitle: i18next.t("projects.sectionTitle"),
  icon: null,
  description: i18next.t("projects.description"),
  categories: [
    {
      name: i18next.t("projects.unb.name"),
      list: [
        {
          url: i18next.t("projects.unb.latitude.url"),
          title: i18next.t("projects.unb.latitude.title"),
          description: i18next.t("projects.unb.latitude.description"),
        },
        {
          url: i18next.t("projects.unb.itrac.url"),
          title: i18next.t("projects.unb.itrac.title"),
          description: i18next.t("projects.unb.itrac.description"),
        },
        {
          url: i18next.t("projects.unb.doarti.url"),
          title: i18next.t("projects.unb.doarti.title"),
          description: i18next.t("projects.unb.doarti.description"),
        },
        {
          url: i18next.t("projects.unb.eupescador.url"),
          title: i18next.t("projects.unb.eupescador.title"),
          description: i18next.t("projects.unb.eupescador.description"),
        },
      ],
    },
    {
      name: i18next.t("projects.tech.name"),
      list: [
        {
          url: i18next.t("projects.tech.startcoding.url"),
          title: i18next.t("projects.tech.startcoding.title"),
          description: i18next.t("projects.tech.startcoding.description"),
        },
      ],
    },
    {
      name: i18next.t("projects.extracurricular.name"),
      list: [
        {
          url: i18next.t("projects.extracurricular.orcestra.url"),
          title: i18next.t("projects.extracurricular.orcestra.title"),
          description: i18next.t("projects.extracurricular.orcestra.description"),
        },
        {
          url: i18next.t("projects.extracurricular.gloria.url"),
          title: i18next.t("projects.extracurricular.gloria.title"),
          description: i18next.t("projects.extracurricular.gloria.description"),
        },
      ],
    },
  ],
};

export default projects;
